import './index.scss';
import { DDRumConfig, RedirectUrl } from '@/config';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { LoginService } from '@/services';
import Cookie from '@/utils/cookie';
import {
  REDIRECT_COOKIE,
  REDIRECT_PARAM,
  resolveRedirectUrl
} from '@/utils/redirect';
import './setupAxios';
import { initDatadogRum } from './datadogRum';
import { consumeResetPasswordEmailHint, isPasswordResetEntry } from '@/utils/passwordResetEntry';

const resetPasswordEmail = consumeResetPasswordEmailHint();

const render = () => {
  ReactDOM.render(
    <BrowserRouter>
      <React.StrictMode>
        <App resetPasswordEmail={resetPasswordEmail} />
      </React.StrictMode>
    </BrowserRouter>,
    document.getElementById('root')
  );
};

const bootstrap = async () => {
  try {
    await LoginService.getUserInfo();

    const redirectCookie = Cookie.get(REDIRECT_COOKIE);
    const redirectParam = new URLSearchParams(window.location.search).get(
      REDIRECT_PARAM
    );

    Cookie.remove(REDIRECT_COOKIE);
    window.location.assign(resolveRedirectUrl({
      cookie: redirectCookie,
      param: redirectParam,
      fallback: RedirectUrl.reporting
    }));
  } catch (err) {
    render();
  }
};

// Explicit reset requests and expired-link recovery must remain reachable even
// when an existing session would normally redirect the visitor to reporting.
if (isPasswordResetEntry(window.location)) {
  render();
} else if (process.env.NODE_ENV === 'production') {
  void bootstrap();
} else {
  render();
}

DDRumConfig.isEnabled && initDatadogRum();
